<template>
  <div>
    <Layout :containers="containers">
      <template v-slot:header>
        <HomeHeroBar
          :hasQuickStartCallout="true"
          :quickStartTitles="[
            { title: 'Get started and sign up', routeName: 'SignUpPage' },
          ]"
          @quickStartCardLinkClicked="quickStartCardLinkClicked"
          @gradientButtonClicked="signupClicked"
        />
      </template>

      <template v-slot:button-tiles>
        <div class="section-padding mobile-padding-top">
          <ButtonTilesContainer :tiles="buttonTiles" />
        </div>
      </template>
      <template v-slot:info-tiles>
        <div class="section-padding">
          <InfoTilesContainer :tiles="infoTiles" />
          <div class="info-tiles-container-padding-match">
            <p>
              * Available in English, Afrikaans, isiZulu, isiXhosa or Sepedi
            </p>
          </div>
        </div>
      </template>
      <template v-slot:create-your-will>
        <CreateYourWillBanner
          @createYourWill="createYourWill"
          :additionalText="'Your will is available in English, Afrikaans, isiZulu, isiXhosa or Sepedi'"
        />
      </template>
      <template v-slot:calculator>
        <div class="section-padding">
          <ImageTextBanner
            :imageUrl="whitelabel.images.homeCalculatorImage"
            :title="'Calculate the cost associated with your death'"
            :paragraphOne="'When you pass away, there will be mandatory fees that your loved ones will be liable for paying.'"
            :boldedParagraph="'Try our free Estate Administration Cost Calculator to find out what you need to plan for.'"
            :reversed="false"
            :buttonText="'Calculate My Costs Now'"
            @gradientButtonClicked="estateCostCalculator"
            :bottomMargin="false"
          />
        </div>
      </template>
      <template v-slot:testimonials>
        <div class="section-padding">
          <TestimonialsSection />
        </div>
      </template>
      <template v-slot:callusback>
        <EstateAdministrationCostCalculatorFooter
          @requestACall="requestACall"
          v-if="whitelabel.brand !== 'quickwill'"
        />
      </template>
    </Layout>
    <SuccessSnackbar v-model="showAlert" :message="alertMessage" />
    <RequestACallDialog
      :showRequestACallDialog.sync="showRequestACallDialog"
      @success="showSuccessMessage"
    />
  </div>
</template>

<script>
  import HomeHeroBar from './HomeHeroBar.vue';
  import ButtonTilesContainer from '../ButtonTilesContainer.vue';
  import InfoTilesContainer from '../InfoTilesContainer.vue';
  import CreateYourWillBanner from '../CreateYourWillBanner.vue';
  import ImageTextBanner from '../ImageTextBanner.vue';
  import TestimonialsSection from '../TestimonialsSection.vue';
  import HR from '../../common/HR.vue';
  import Layout from '../../common/layouts/Layout.vue';
  import DynamicNavDrawer from '../../guest/DynamicNavDrawer.vue';
  import DrawerSignUp from '../../guest/DrawerSignUp.vue';
  import DrawerSignIn from '../../guest/DrawerSignIn.vue';
  import SuccessSnackbar from '../../common/SuccessSnackbar.vue';
  import EstateAdministrationCostCalculatorFooter from '../EstateCostCalculator/EstateAdministrationCostCalculatorFooter.vue';
  import RequestACallDialog from '../dialogs/RequestACallDialog.vue';

  export default {
    name: 'HomeAlternative',
    metaInfo() {
      return {
        link: [
          {
            rel: 'canonical',
            href: this.whitelabel.canonicalUrls.homepage,
          },
        ],
      };
    },
    props: {
      openSignupDrawerImmediately: {
        required: false,
        default: false,
        type: Boolean,
      },
      isReferralLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      isActivationLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      isPasswordResetLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      verifyUserLinkCode: {
        required: false,
        default: null,
        type: Object,
      },
    },
    components: {
      HomeHeroBar,
      ButtonTilesContainer,
      InfoTilesContainer,
      CreateYourWillBanner,
      ImageTextBanner,
      TestimonialsSection,
      DynamicNavDrawer,
      HR,
      Layout,
      DrawerSignUp,
      DrawerSignIn,
      SuccessSnackbar,
      EstateAdministrationCostCalculatorFooter,
      RequestACallDialog,
    },
    data(props) {
      return {
        signUpDrawerOpen: props.openSignupDrawerImmediately,
        signInDrawerOpen: false,
        showAlert: false,
        alertMessage: null,
        countryPattern: require('@/assets/shared/redesign/backgrounds/country-pattern.svg'),
        greenAccentOne: require('@/assets/shared/redesign/backgrounds/green-accent-1.svg'),
        greenAccentTwo: require('@/assets/shared/redesign/backgrounds/green-accent-2.svg'),
        purpleAccent: require('@/assets/shared/redesign/backgrounds/purple-accent.svg'),
        tribalPattern: require(`@/assets/old_mutual/homepage/generic.svg`),
        showRequestACallDialog: false,
      };
    },
    mounted() {
      if (localStorage.getItem('isLandingSimple')) {
        localStorage.removeItem('isLandingSimple');
        location.reload();
      }
    },
    methods: {
      successResetPassword() {
        this.signInDrawerOpen = false;
        this.alertMessage =
          this.whitelabel.authentication.resetPassword.successMessage;
        this.showAlert = true;
      },
      loginClicked() {
        this.signUpDrawerOpen = false;
        this.signInDrawerOpen = true;
      },
      signupClicked() {
        this.$router.push('/register');
      },
      drawerClosed() {
        this.signUpDrawerOpen = false;
      },
      signInDrawerClosed() {
        this.signInDrawerOpen = false;
      },
      quickStartCardLinkClicked(routeName) {
        if (routeName === 'SignUpPage') {
          this.signUpDrawerOpen = true;
        } else {
          this.$router.push({ name: routeName });
        }
      },
      createYourWill() {
        this.$router.push('/register');
      },
      estateCostCalculator() {
        this.$router.push({
          name: 'Calculators',
        });
      },
      // buttonAction(action) {
      //   if (action === "SignUp") {
      //     this.signUpDrawerOpen = true;
      //   }
      // },
      requestACall() {
        this.showRequestACallDialog = true;
      },
      showSuccessMessage(success) {
        this.$emit('success', success);
      },
    },
    computed: {
      containers() {
        return [
          {
            name: 'header',
            background: 'countryPattern',
            class: 'hero-banner',
          },
          {
            name: 'button-tiles',
            background: 'countryPattern',
            fadedRow: true,
            hr: true,
            accents: ['green-accent-1'],
          },
          { name: 'info-tiles' },
          {
            name: 'create-your-will',
            class: 'section-margin',
          },
          {
            name: 'calculator',
            background: 'accent',
            accents: ['green-accent-2', 'purple-accent-1'],
          },
          { name: 'testimonials' },
          { name: 'callusback' },
        ];
      },
      buttonTiles() {
        return [
          {
            imageUrl: this.whitelabel.images.homeButtonTileOne,
            title: 'A straightforward process ',
            description: `Planning for the future can be overwhelming. Our guided, expert-backed process makes it easy, ensuring your final wishes are securely recorded in your <a href="/articles/your-will-in-a-language-you-call-your-own" target="_blank" rel="noopener">home language*</a>.`,
          },
          {
            imageUrl: this.whitelabel.images.homeButtonTileTwo,
            title: 'Customised estate protection',
            description: `When you pass, your loved ones will face estate administration costs. EstateAssist offers cover for estate costs, education and cash flow needs, and debt protection.`,
          },
          {
            imageUrl: this.whitelabel.images.homeButtonTileThree,
            title: 'Easy updates',
            description: `Life changes, and your will should too. Log in, update your will, and finalise the new version. It’s quick, simple, and keeps your will aligned with your wishes.`,
          },
        ];
      },
      infoTiles() {
        return [
          {
            imageUrl: this.whitelabel.images.homeInfoTitleOne,
            title: 'Trusted expertise',
            description:
              'A step-by-step process, built by professionals with expert support every step of the way.',
          },
          {
            imageUrl: this.whitelabel.images.homeInfoTitleTwo,
            title: 'Accessibility',
            description:
              'Create your will anytime, anywhere, and download it in your <a href="/articles/your-will-in-a-language-you-call-your-own" target="_blank" rel="noopener">home language*</a>.',
          },
          {
            imageUrl: this.whitelabel.images.homeInfoTitleThree,
            title: 'Straightforward process',
            description:
              'Expert-designed steps make creating your will easier than you think.',
          },
          {
            imageUrl: this.whitelabel.images.homeInfoTitleFour,
            title: 'Comprehensive solutions',
            description:
              'From planning to protection, secure your legacy with our estate services.',
          },
        ];
      },
    },
  };
</script>
<style lang="scss" scoped>
  .info-tiles-container-padding-match {
    font-style: italic;
    padding-left: 66px;
  }

  @media only screen and (min-width: 601px) and (max-width: 807px) {
    .mobile-padding-top {
      padding-top: 111px;
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 600px) {
    .mobile-padding-top {
      padding-top: 133px;
    }
  }
</style>
